import { LeetCodePlayground } from '~components/mdx/LeetCode';
import React from 'react';
export default {
  LeetCodePlayground,
  React
};